/**
 * Client-side permission helpers.
 *
 * The server sends the current user's derived granular capabilities
 * ("module:action", e.g. "patients:write") on their permission record, plus an
 * isSuperAdmin flag for the admin bypass. Everything funnels through can();
 * hasModuleAccess / hasWriteAccess are thin back-compat wrappers expressed in
 * terms of it. The client is UX-only — the server's authorize() is the gate.
 */

/** The single client-side capability check (mirrors the server's can()). */
export function can(permissions, capability) {
    if (!permissions) return false;
    if (permissions.isSuperAdmin) return true;
    return Array.isArray(permissions.capabilities) && permissions.capabilities.includes(capability);
}

/** "Can this user see/use module X" — i.e. can read it. */
export function hasModuleAccess(permissions, role, moduleKey) {
    if (role === 'admin') return true;
    return can(permissions, `${moduleKey}:read`);
}

/** "Can this user modify module X" — i.e. can write it. */
export function hasWriteAccess(permissions, role, moduleKey) {
    if (role === 'admin') return true;
    return can(permissions, `${moduleKey}:write`);
}
